import theme from '@/presentation/assets/styles/theme'

const SxLoggedHeader = {
  divider: {
    color: theme.palette.grey[50],
    '&.MuiDivider-fullWidth': { marginTop: 0, marginBottom: 0 }
  },
  appBar: (shadow: boolean, onTop?: boolean) => {
    return {
      bgcolor: 'common.white',
      boxShadow: shadow ? '0 4px 20px 0 rgba(0, 0, 0, 0.16)' : 'none',
      zIndex: onTop ? 20 : 10
    }
  },
  appBarNoShadow: {
    bgcolor: 'common.white',
    boxShadow: 'none',
    height: '100%'
  }
}

export default SxLoggedHeader
